<section class="container" *ngFor="let pallet of pallets" id="{{pallet.tagRfid}}">
  <div class="banner warning-background" *ngIf="pallet?.cratesUnderAlert?.length">
    <p>PALLET BLOQUEADO</p>
    <p class="description">
      Para mais informações, acesse <strong (click)="openPalletDetails(pallet)">Dados do Pallet</strong>.
    </p>
  </div>
  <div class="details">
    <div class="row warning" *ngIf="pallet.position === 'SECTION'">
      <i class="uil uil-exclamation-triangle"></i>
      <p>
        Esta é a posição no momento da leitura do recebimento deste pallet. Alterações da posição podem ter sido
        realizadas no processo de descarregamento.
      </p>
    </div>
    <div class="row bottom">
      <section>
        <app-info-oc-or-nfe label="rfId" [value]="pallet.tagRfid"
        *ngIf="pallet.type !== CrateTypeEnum.REMAINS">
      </app-info-oc-or-nfe>
      <app-info-oc-or-nfe label="rfId" [value]="'N/A'"
        *ngIf="pallet.type === CrateTypeEnum.REMAINS">
      </app-info-oc-or-nfe>
      <app-info-oc-or-nfe label="Tipo" [value]="formatType(pallet.type)"></app-info-oc-or-nfe>
        <app-info-oc-or-nfe label="Estado" [value]="translatePalletState(pallet.state)"></app-info-oc-or-nfe>
        <app-info-oc-or-nfe label="Nível" *ngIf="pallet?.groundPositionGroupLevelName?.length"
          [value]="pallet.groundPositionGroupLevelName">
        </app-info-oc-or-nfe>
        <app-info-oc-or-nfe label="Altura" *ngIf="!pallet?.groundPositionGroupLevelName?.length"
          [value]="pallet.z >= 0 ? pallet.z + 'cm' : 'indefinida'">
        </app-info-oc-or-nfe>
      </section>
      <div class="btn-container">
        <div class="btn-row top-row">
          <button mat-raised-button class="secondary-2" (click)="openPalletDetails(pallet)">Dados do Pallet</button>
          <button mat-raised-button class="secondary-2" (click)="openHistory(pallet)">Histórico</button>
          <button mat-raised-button class="secondary-2" (click)="openComments(pallet)">Comentários</button>
        </div>
        <div class="btn-row bottom-row">

          <button mat-raised-button class="primary-2" (click)="inventoryPallet(pallet)"
            [disabled]="pallet.type === CrateTypeEnum.REMAINS"
            [matTooltip]="pallet.type === CrateTypeEnum.REMAINS ? 'Pallets fracionados não podem ser inventariados.' : null"
            matTooltipClass="line-break-tooltip">
            Inventariar
          </button>
          <button mat-raised-button class="primary-2" (click)="relocatePallet(pallet)"
            [disabled]="!canRelocate(sendTaskTypesEnum.RELOCATE_POSITION, userRole)">
            Realocar
          </button>
          <button mat-raised-button class="warning" *ngIf="!pallet?.cratesUnderAlert?.length"
            (click)="blockPallet(pallet)"
            [disabled]="pallet.type === CrateTypeEnum.REMAINS"
            [matTooltip]="pallet.type === CrateTypeEnum.REMAINS ? 'Pallets fracionados não podem ser bloqueados.' : null"
            matTooltipClass="line-break-tooltip">
            Bloquear
          </button>
          <button mat-raised-button class="warning" *ngIf="pallet?.cratesUnderAlert?.length"
            (click)="unblockPallet(pallet)">
            Desbloquear
          </button>
        </div>
      </div>
    </div>
  </div>
  <app-product-list [products]="pallet.skuGroups"></app-product-list>
</section>
